(function () {
  function init() {
    var form = document.getElementById('gt-form-misure');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var bodyField = form.querySelector('[name="contact[body]"]');
      if (!bodyField) return;

      var capoRadio = form.querySelector('input[name="gt-capo"]:checked');
      var capo = capoRadio ? capoRadio.value : '';
      var panel = form.querySelector('.gt-panel--' + capo);
      var noteField = form.querySelector('#gt-note');
      var lines = ['Capo: ' + capo];

      if (panel) {
        panel.querySelectorAll('[data-misura]').forEach(function (inp) {
          if (inp.value.trim()) {
            lines.push(inp.dataset.misura + ': ' + inp.value.trim() + ' cm');
          }
        });
      }

      if (noteField && noteField.value.trim()) {
        lines.push('', 'Note: ' + noteField.value.trim());
      }

      bodyField.value = lines.join('\n');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
